import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box, useTheme } from '@mui/material';
// components
import { useSettingsContext } from '@raas/shared/src/components/minimals/settings';
// hooks
import useResponsive from '@raas/shared/src/hooks/useResponsive';
//
import Header from '@raas/shared/src/components/header';
import Main from './Main';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();

  const theme = useTheme();

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;

  if (isNavHorizontal) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        {isDesktop ? <NavHorizontal /> : renderNavVertical}
        <Main sx={{ backgroundColor: theme.palette.background.neutral }}>
          <Outlet />
        </Main>
      </>
    );
  }

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main
            sx={{
              backgroundColor: theme.palette.background.neutral,
              minHeight: {
                lg: `calc(100vh)`,
                marginTop: '12px',
              },
            }}
          >
            <Outlet />
          </Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main
          sx={{
            backgroundColor: theme.palette.background.neutral,
            minHeight: {
              lg: `calc(100vh)`,
              marginTop: '12px',
            },
          }}
        >
          <Outlet />
        </Main>
      </Box>
    </>
  );
}
